// import axios from "axios";
// import env from "../config";
import axios from "../api/axios";
// const client = axios.create({
//   baseURL: env.METADATA_TOOLS_ENDPOINT,
//   json: true,
// });

export default {
  async execute(method, resource, data,requestheader = {}) {
    return axios.metaDataToolsEndPoint({
      method,
      url: resource,
      data,
      headers: requestheader
    }).then((req) => {
      return req.data;
    });
  },
  UploadMetadataTools(payload,headerpayload){
    let requestheader = headerpayload
    return this.execute("post", `/MetadataUpdate`,payload,
    requestheader
    );
  },
  GetMetadataTools(payload){
    return this.execute("get", `/MetadataUpdate/Logs`,null,payload);
  },
  ExecuteMetadataTools(payload,headerpayload){
    return this.execute("put", `/MetadataUpdate/Execute`,payload,headerpayload);
  },
  GetMetadataById(toolId,headerpayload){
    return this.execute("get", `/MetadataUpdate/Log/${toolId}`,null,headerpayload);
  },
};
